<script>
import getId from '@/utils/getIdFromLink'

export default {
  data () {
    return {
      itemsArray: [],
      vatRates: [],
      measures: []
    }
  },

  computed: {
    invoiceUpdated () {
      return this.$store.state.modals.exsbinvoices.update.invoiceReload
    },

    invoiceType () {
      return parseInt(this.getIdLink(this.item.invoiceType))
    },

    hasId () {
      if (this.item && this.item['@id']) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    invoiceUpdated () {
      if (this.invoiceUpdated === 1) {
        this.$store.state.modals.exsbinvoices.update.invoiceReload = 0
        if (this.idInvoice > 0) {
          this.retrieve(decodeURIComponent('/core/public/index.php/api/e_x_s_b_invoices/' + this.idInvoice))
        } else {
          this.retrieve(decodeURIComponent(this.$route.params.id))
        }
      }
    },

    item: function () {
      this.prepareDataAfterRetrieve(this.item)
    }
  },

  methods: {
    prepareDataAfterRetrieve (item) {
      item.issueDate = this.$moment(item.issueDate).format('YYYY-MM-DD')
      item.sellDate = this.$moment(item.sellDate).format('YYYY-MM-DD')
      item.paymentDeadline = this.$moment(item.paymentDeadline).format('YYYY-MM-DD')
      item.totalVatAmount = parseFloat(item.totalVatAmount).toFixed(2)
      item.totalValueBrutto = parseFloat(item.totalValueBrutto).toFixed(2)
      item.totalValueNetto = parseFloat(item.totalValueNetto).toFixed(2)
      item.paid = parseFloat(item.paid).toFixed(2)
      item.toPay = parseFloat(item.toPay).toFixed(2)
      for (let i in item.invoicePositions) {
        item.invoicePositions[i].vatAmount = parseFloat(item.invoicePositions[i].vatAmount).toFixed(2)
        item.invoicePositions[i].valueNetto = parseFloat(item.invoicePositions[i].valueNetto).toFixed(2)
        item.invoicePositions[i].valueBrutto = parseFloat(item.invoicePositions[i].valueBrutto).toFixed(2)
        item.invoicePositions[i].priceNettoPerUnit = parseFloat(item.invoicePositions[i].priceNettoPerUnit).toFixed(2)
        item.invoicePositions[i].priceBrutto = parseFloat(item.invoicePositions[i].priceBrutto).toFixed(2)
      }
      if (item.invoiceCorrectionOf) {
        this.prepareDataAfterRetrieve(item.invoiceCorrectionOf)
      }
    },
    menageData () {
      this.$store.state.modals.exsbinvoices.update.dataUpdateShow = 1
      this.$store.state.modals.exsbinvoices.update.idInvoice = this.getIdLink(this.item['@id'])
    },
    menagePositions () {
      this.$store.state.modals.exsbinvoices.update.positionsUpdateShow = 1
      this.$store.state.modals.exsbinvoices.update.idInvoice = this.getIdLink(this.item['@id'])
    },
    calculateTotalSums () {
      this.item.totalSums = []
      this.item.totalValueNetto = 0.00
      this.item.totalVatAmount = 0.00
      this.item.totalValueBrutto = 0.00
      for (let vr in this.vatRates) {
        let object = {
          vatRange: this.vatRates[vr].range,
          totalValueNetto: 0,
          totalVatAmount: 0,
          totalValueBrutto: 0
        }
        this.item.totalSums.push(object)
      }
      let finalObject = {
        vatRange: '-',
        totalValueNetto: 0,
        totalVatAmount: 0,
        totalValueBrutto: 0
      }
      this.item.totalSums.push(finalObject)
      for (let ip in this.item.invoicePositions) {
        for (let vr in this.vatRates) {
          if (this.vatRates[vr]['@id'] === this.item.invoicePositions[ip].vatRate) {
            let vatRange = this.vatRates[vr].range
            for (let tsa in this.item.totalSums) {
              if (vatRange === this.item.totalSums[tsa].vatRange) {
                this.item.totalSums[tsa].totalValueNetto = (parseFloat(this.item.totalSums[tsa].totalValueNetto) + parseFloat(this.item.invoicePositions[ip].valueNetto)).toFixed(2)
                this.item.totalSums[tsa].totalVatAmount = (parseFloat(this.item.totalSums[tsa].totalVatAmount) + parseFloat(this.item.invoicePositions[ip].vatAmount)).toFixed(2)
                this.item.totalSums[tsa].totalValueBrutto = (parseFloat(this.item.totalSums[tsa].totalValueBrutto) + parseFloat(this.item.invoicePositions[ip].valueBrutto)).toFixed(2)
                this.item.totalValueNetto = (parseFloat(this.item.totalValueNetto) + parseFloat(this.item.invoicePositions[ip].valueNetto)).toFixed(2)
                this.item.totalVatAmount = (parseFloat(this.item.totalVatAmount) + parseFloat(this.item.invoicePositions[ip].vatAmount)).toFixed(2)
                this.item.totalValueBrutto = (parseFloat(this.item.totalValueBrutto) + parseFloat(this.item.invoicePositions[ip].valueBrutto)).toFixed(2)
              }
            }
          }
        }
      }
    },
    addNewPosition () {
      let object = {
        item: '',
        priceNettoPerUnit: '0.00',
        pricePerUnitBrutto: '0.00',
        valueNetto: '0.00',
        valueBrutto: '0.00',
        quantity: 1,
        vatAmount: '0.00',
        vatRate: null
      }
      this.item.invoicePositions.push(object)
    },
    getMeasures () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_measures', {
          params
        })
        .then(response => {
          this.measures = []
          this.measures = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getVatRates () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_vat_rates', {
          params
        })
        .then(response => {
          this.vatRates = []
          this.vatRates = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getItems () {
      let params = {
        'pagination': false
      }
      this.$http
        .get('api/e_x_s_b_items', {
          params
        })
        .then(response => {
          this.itemsArray = []
          this.itemsArray = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
